import { render, staticRenderFns } from "./GlossaryLetters.vue?vue&type=template&id=04d0fe5f&scoped=true&"
import script from "./GlossaryLetters.vue?vue&type=script&lang=js&"
export * from "./GlossaryLetters.vue?vue&type=script&lang=js&"
import style0 from "./GlossaryLetters.vue?vue&type=style&index=0&id=04d0fe5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d0fe5f",
  null
  
)

export default component.exports